import { render, staticRenderFns } from "./GridCurrencyColumn.vue?vue&type=template&id=7b36fb60&"
import script from "./GridCurrencyColumn.vue?vue&type=script&lang=ts&"
export * from "./GridCurrencyColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports